import { render, staticRenderFns } from "./BankAccountIban.vue?vue&type=template&id=3de2f1f3&scoped=true"
import script from "./BankAccountIban.vue?vue&type=script&lang=js"
export * from "./BankAccountIban.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de2f1f3",
  null
  
)

export default component.exports